import React, { useEffect, useState } from 'react';
import { academicProgramsService } from '../../../services';
import { RequestNav } from '../../../components/academic-affair-program-requests/components/program-requests-requestNav';
import { RequestDetailsPanel } from '../../../components/academic-affair-program-requests/components/view/RequestDetailsPanel';
import { RequestLogHistory } from '../../../components/academic-affair-program-requests/components/admin/program-requests-RequestLogs';
import { RequestActionFooter } from '../../../components/academic-affair-program-requests/components/view/RequestActionFooter';
import eventEmitter from '../../../shared/eventEmitter';

export const ProgramRequestAdminViewPage = props => {
    const [programRequestLogData, setProgramRequestLogData] = useState([]);
    const [requestNavData, setRequestNavData] = useState([]);
    const [currentRequestData, setCurrentRequestData] = useState([]);
    const [requestId, setRequestId] = useState(-1);

    useEffect(() => {
        const query = props.location.state;
        if (query) {
            for (let param of query) {
                setRequestNavData(param.otherRequests);
                setCurrentRequestData(param.rowData);
                setRequestId(param.requestID);
            }
        }
    }, [props.location.state]);

    useEffect(() => {
        const handleDataUpdate = () => {
            const res = academicProgramsService.getAllProgramRequests();
            Promise.resolve(res).then(data => {
                const navData = data.filter(
                    x => x.statusId === currentRequestData.statusId
                );
                setRequestNavData(navData ?? []);
            });
        };
        eventEmitter.on('updateSARData', handleDataUpdate);
        return () => {
            eventEmitter.off('updateSARData', handleDataUpdate);
        };
    }, [currentRequestData]);

    useEffect(() => {
        if (requestId === -1 || requestNavData.length === 0) return;

        const res = academicProgramsService.getProgramRequestLogs(requestId);
        Promise.resolve(res).then(data => {
            setProgramRequestLogData(data ?? []);
        });

        let newData = requestNavData.find(x => x.requestID === requestId);
        if (newData === undefined) {
            newData = requestNavData[0];
            setRequestId(newData.requestID);
        } else {
            setCurrentRequestData(newData ?? []);
        }
    }, [requestId, requestNavData]);

    return (
        <div className="program-request-details">
            <RequestNav
                requestNavData={requestNavData}
                currentRequestId={requestId}
                setCurrentRequestId={setRequestId}
            />
            <RequestDetailsPanel
                requestDetails={currentRequestData}
                requestLogs={programRequestLogData}
                showBackButton={false}
                footer={
                    <RequestActionFooter
                        requestLogs={programRequestLogData}
                        userInput={currentRequestData}
                        requestStatus={currentRequestData.status}
                    />
                }
            >
                <RequestLogHistory
                    requestLogs={programRequestLogData}
                    requestStatus={currentRequestData.status}
                    userInput={currentRequestData}
                    showActions={false}
                />
            </RequestDetailsPanel>
        </div>
    );
};
